import { loadCart } from "./cart/cartActions";
import { loadAddresses } from "./addressActions";
import ThunkDispatch from "../interfaces/ThunkDispatch";
import ThunkAction from "../interfaces/ThunkAction";
import GetCartConfig from "../interfaces/cart/GetCartConfig";
import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import Cart from "../interfaces/cart/Cart";
import GlobalState from "../interfaces/GlobalState";
import CartMessage from "../interfaces/cart/CartMessage";
import PageNameEnum from "../enums/PageNameEnum";
import CartMessageLevelEnum from "../enums/CartMessageLevelEnum";
import eventEmitter from "../events/eventEmitter";
import UserSessionUpdatedEvent from "../events/events/UserSessionUpdatedEvent";

// ------------------------- [ Action Creators ] -------------------------

export const setIsLoading = (isLoading: boolean): Action => ({
    type: ActionTypeEnum.APP_IS_LOADING_SET,
    isLoading,
});

const setHasBootstrapLoaded = (hasLoaded: boolean): Action => ({
    type: ActionTypeEnum.APP_HAS_BOOTSTRAP_LOADED_SET,
    hasLoaded,
});

export const setAppMessages = (messages: CartMessage[]): Action => ({
    type: ActionTypeEnum.APP_MESSAGES_SET,
    messages,
});

export const clearAppMessages = (): Action => setAppMessages([]);

export const addAppMessage = (messageHtml: string, pagesVisible: PageNameEnum[], level: CartMessageLevelEnum = CartMessageLevelEnum.ERROR): Action => ({
    type: ActionTypeEnum.APP_MESSAGES_ADD,
    message: {
        code: null,
        message_html: messageHtml,
        level,
        pages_visible: pagesVisible,
    },
});

// ------------------------- [ Thunks ] -------------------------

// By default, we only validate and auto-remove products on pages that surface the validation messages.
export const loadBootstrap = (cartUuid?: string, config: GetCartConfig = {}): ThunkAction<Promise<Cart>> => (
    async (dispatch: ThunkDispatch, getState: () => GlobalState) => {
        // Get the cart from state if a cart UUID wasn't provided.
        // This is done for performance purposes when the cart already exists, such as when transitioning from CartPage to ShippingAddressPage.
        const cart = cartUuid
            ? await dispatch(loadCart(cartUuid, config))
            : getState().cart;

        if (!cart) {
            throw new Error("Cart is null. The `cartUuid` argument is REQUIRED when cart does not exist in state.");
        }

        // If the cart is associated to a customer, we know the client is authenticated as the customer. Load their addresses.
        if (cart.customer_id) {
            await dispatch(loadAddresses(cart.customer_id));
        }

        dispatch(setHasBootstrapLoaded(true));
        console.debug("Successfully loaded bootstrap.", cartUuid, config);

        eventEmitter.emit(
            new UserSessionUpdatedEvent(cart),
        );

        return cart;
    }
);
